import React from "react";
import "./VisionHome.scss";
import rupaliIcon from "../../../assets/rupali-logo-shade.svg";
import useAboutUs from "../../../hooks/useAboutUs";

const VisionHome = () => {
  const [aboutUs, setAboutUs] = useAboutUs();

  const visionData = aboutUs.filter(
    (vision) => vision.DescType === "VisionMission"
  );
  // console.log("vision Data", visionData);

  let missionDesciption = "";

  if (visionData[1]?.Description) {
    missionDesciption = visionData[1]?.Description.split("<br/>");
  }

  return (
    <>
      <div className="container-fluid p-0">
        <div className="vision_home">
          <div className="container">
            <div className="vision_home_content">
              <h2 data-aos="zoom-out-right">Vision & Mission</h2>
              <hr />

              <div
                className="row justify-content-between"
                data-aos="fade-up"
                data-aos-anchor-placement="bottom-bottom"
              >
                <div className="col-lg-5 my-auto">
                  <div className="left">
                    <h4>Vision</h4>
                    <ul>
                      <li>{visionData[0]?.Description}</li>
                    </ul>
                  </div>
                </div>

                <div className="col-lg-6 mt-5 mt-lg-0">
                  <div className="right">
                    <h4>Mission</h4>

                    <ul>
                      {Array(missionDesciption.length)
                        .fill(1)
                        .map((el, i) => (
                          <li key={i}>{missionDesciption[i]}</li>
                        ))}
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="container logo_shade">
          {/* <img src={rupaliIcon} className="img-fluid" alt="" /> */}
        </div>
      </div>
    </>
  );
};

export default VisionHome;
